// export default ['EA', 'REA','ED','REG'];

export default [
  {
    label: 'Early Action',
    value: 'EA',
  },
  {
    label: 'Restrictive Early Action',
    value: 'REA'
  },
  {
    label: 'Early Decision',
    value: 'ED',
  },
  {
    label: 'Regular Decision',
    value: 'REG',
  },
  {
    label: 'Rolling Admission',
    value: 'RO',
  },
  {
    label: 'Other',
    value: 'other',
  },
];
